import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{templates:MasterTableDataType[],totalCount:number}>>=>{
    const result = await instance.post(`${MastersApi.getLabTemplate}`,{...params,clinicId});
    return result.data;
}

export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.saveLabTemplate}`,params);
    return result.data;
}

